import React from 'react';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useLocation, useParams } from 'react-router-dom';
import { useGlobalContext } from '../../contexts/GlobalContext';

//Servicios
import { UserService } from '../../services/api';
import Spinner from '../spinner/Spinner';
import Comments from './Comments';

function CommentsContainer() {
    const { toast, token } = useGlobalContext();

    const Location = useLocation();

    const { register, handleSubmit, setError, formState } = useForm();

    const [loader, setLoader] = useState(false);

    const onSubmit = async (formData) => {
        try {
            setLoader(true);

            let sendComment = await UserService.sendComment({
                token,
                url: Location.pathname,
                ...formData,
            });

            if (sendComment) {
                toast('Comentario enviado con éxito', { type: 'success' });
            }

            setLoader(false);
        } catch (err) {
            setLoader(false);
            toast(
                'No se pudo enviar el comentario, intente denuevo mas tarde',
                { type: 'error' }
            );
            return err;
        }
    };

    return loader ? (
        <Spinner />
    ) : (
        <Comments
            states={{ loader }}
            functions={{
                register,
                handleSubmit,
                setError,
                formState,
                onSubmit,
            }}
        />
    );
}

export default CommentsContainer;
